'use client';

import PreviousButtonCommon from './previous-button-common';

const PreviousButtonDesktop = () => {
  return (
    <PreviousButtonCommon
      className="size-12 shrink-0 bg-primary-50 text-black hover:bg-primary-100"
      arrowClassName="size-4"
    />
  );
};

export default PreviousButtonDesktop;
